import React, { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext'; // Import AuthContext
import './MenuItems.css';

const MenuItems = () => {
  const { moduleAccess } = useContext(AuthContext); // Get module access data
  const navigate = useNavigate();
  const location = useLocation();

  // Define all possible menu items with corresponding access keys
  const menuItems = [
    { name: 'About', path: '/ceo', accessKey: 'about' },
    { name: '<br />' }, // Line break after About
    { name: 'Bakery', path: '/bakery', accessKey: 'bakery' },
    { name: 'Butchery', path: '/butchery', accessKey: 'butchery' },
    { name: 'Fruit & Veg', path: '/fruitveg', accessKey: 'fruitveg' },
    { name: 'Take-away', path: '/takeaway', accessKey: 'takeaway' },
    { name: 'CFC', path: '/cfc', accessKey: 'cfc' },
    { name: '<br />' }, // Line break before Br. Manager
    { name: 'Br. Manager', path: '/brmanager', accessKey: 'brmanager' }
  ];
  
  const handleClick = (path) => {
    navigate(path);
  };

  return (
    <div className="menu-buttons">
      {menuItems
        .filter(item => !item.accessKey || moduleAccess[item.accessKey]) // Only show items with access
        .map((item, index) => (
          item.name === '<br />' ? 
            <br key={index} /> : 
            <button
              key={index}
              className={`menu-button ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => handleClick(item.path)}
            >
              {item.name}
            </button>
        ))}
    </div>
  );
  
};

export default MenuItems;
